var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as languages from '../constants/Language';
import * as enMessages from '../localization/en';
import * as ruMessages from '../localization/ru';
import * as uzMessages from '../localization/uz';
import * as kkMessages from '../localization/kk';
export function localization(languageId) {
    var messages = enMessages;
    if (languageId === languages.RU) {
        messages = ruMessages;
    }
    if (languageId === languages.UZ) {
        messages = uzMessages;
    }
    if (languageId === languages.KK) {
        messages = kkMessages;
    }
    return __assign(__assign({}, messages), { languageId: languageId });
}



// WEBPACK FOOTER //
// ./src/containers/gridLocalization.js